if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        config.headers['Content-Type'] = 'application/json';
        // delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        const giftCheckbox = document.querySelector('#gift-product');
        const properties = {};

        formData.forEach((value, key) => {
          if (key.includes('properties[')) {
            const propertyName = key.match(/\[(.*?)\]/)?.[1];

            if (propertyName) {
              properties[propertyName] = value;
            }
          }
        });

        const qtyInput = this.form?.querySelector('input[name="quantity"]') || this.closest('sticky-atc-bar')?.querySelector('input[name="quantity"]') || this.querySelector('input[name="quantity"]');
        const productQuantity = qtyInput ? (parseInt(qtyInput.value) || 1) : (parseInt(formData.get('quantity')) || 1);

        const idInput = this.form?.querySelector('[name="id"]') || this.closest('sticky-atc-bar')?.querySelector('[name="id"]') || this.querySelector('[name="id"]');
        const variantId = (idInput ? idInput.value : formData.get('id')) || formData.get('id');

        const items = [
          {
            id: variantId,
            quantity: productQuantity,
            properties: properties
          }
        ];

        if (giftCheckbox?.checked) {
          const giftVariantId = giftCheckbox.dataset.giftVariant;

          if (giftVariantId) {
            const uniqueKey = Date.now().toString();

            // Main Product
            items[0].properties = {
              ...properties,
              _gift_id: uniqueKey,              
              _gift_handle: giftCheckbox.dataset.giftHandle
            };

            items.push({
              id: giftVariantId,
              quantity: 1,
              properties: {
                _gift_product: 'yes',
                _gift_id: uniqueKey,
                _gift_handle: giftCheckbox.dataset.giftHandle
              }
            });
          }
        }

        const data = {
          items
        };

        if (this.cart) {
          data.sections = this.cart.getSectionsToRender().map(
            (section) => section.id
          );

          data.sections_url = window.location.pathname;

          this.cart.setActiveElement(document.activeElement);
        }
        config.body = JSON.stringify(data);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
            .then((res) => res.text())
            .then((htmlText) => {

              const html = new DOMParser().parseFromString(htmlText, 'text/html');

              const newBubble = html.querySelector('#cart-icon-bubble');
              const currentBubble = document.querySelector('#cart-icon-bubble');

              if (newBubble && currentBubble) {
                currentBubble.innerHTML = newBubble.innerHTML;
              }

            });
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('bz-quick-view');
            const BzModal = this.closest('bz-modal');
            if(BzModal){
              BzModal?.close();
            }
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
